// extracted by mini-css-extract-plugin
export default {"box":"index_box__BXKRo","iconBox":"index_iconBox__e1YOw","icon":"index_icon__Yzg0y","input":"index_input__8Tlw9"};